import api, { checkTokenErrorResponse } from '..';

const billTypes = [
    [0, "Pagar"],
    [1, "Receber"],
]

const paymentMethods = [
    [0, 'Dinheiro'],
    [1, 'Pix'],
    [2, 'Crédito à vista'],
    [3, 'Crédito parcelado'],
    [4, 'Débito'],
    [5, 'Boleto'],
    [6, 'Cheque'],
];

export async function getBills() {
    return api.get("contasAcademia/")
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


export async function postBill(centro_de_custo, parceiro, descricao, moeda, numero_parcelas, parcelas = [], obs, tipo, situacao = false) {
    const data = {
        
        centro_de_custo,
        parceiro,
        descricao,
        moeda,
        numero_parcelas,
        obs,
        tipo,
        situacao,
        parcelas
    };
    return api.post(`contasAcademia/`, data)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


export async function getBill(id) {
    return api.get(`contasAcademia/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function deleteBill(id) {
    return api.delete(`contasAcademia/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function pathcBill(id, centro_de_custo, parceiro, descricao, moeda, numero_parcelas, parcelas = [], obs, situacao = false) {
    const data = {
        centro_de_custo,
        parceiro,
        descricao,
        moeda,
        numero_parcelas,
        obs,
        situacao,
        parcelas
    };

    return api.patch(`contasAcademia/${id}/`, data)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


export async function postBillPayment(id, idParcela, data_pag, valor_pago, forma_pagamento) {
    const formdata = new FormData();

    formdata.append("data_pag", data_pag);
    formdata.append("valor_pago", valor_pago);
    formdata.append("forma_pagamento", forma_pagamento);

    return api.post(`contasAcademia/${id}/registrar_pagamento/${idParcela}/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function putBillPayment(id, idParcela, data_pag, valor_pago, data_venc, valor,forma_pagamento) {
    const formdata = new FormData();
    if(data_pag)
        formdata.append("data_pag", data_pag);
    if(valor_pago)    
        formdata.append("valor_pago", valor_pago);
    if(data_venc)
        formdata.append("data_venc", data_venc);
    if(valor)    
        formdata.append("valor", valor);
    if(forma_pagamento !== "")
    formdata.append("forma_pagamento", forma_pagamento);

    return api.put(`contasAcademia/${id}/parcelas/${idParcela}/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};



const academyBillServices = {
    getBill,
    getBills,
    postBill,
    deleteBill,
    pathcBill,
    postBillPayment,
    putBillPayment,
    billTypes,
    paymentMethods
}
export default academyBillServices;